.header {
    border-bottom: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;
}

.body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.actions {
    border-top: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;
}

/* Fullscreen mode */
.fullScreenContent.fullScreenContent {
    /* Mantine puts this class on the viewport-fixed inner AND the content,
       so size both at 100% — the 24px x/yOffset provides the even gutter.
       Doubled class beats Mantine's own auto-sizing content rule. */
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

/* Shift only Mantine's viewport inner below the fixed navbar;
   the dialog content fills the remaining space with 24px gutters. */
:global(body:has(#navbar-header[data-has-visible-fixed-navbar='true']))
    .fullScreenContent.fullScreenContent:not([data-modal-content]) {
    height: calc(100% - var(--navbar-height));
    margin-top: var(--navbar-height);
}

:global(
        body:has(
            #navbar-header[data-has-visible-fixed-navbar='true'][data-has-banner='true']
        )
    )
    .fullScreenContent.fullScreenContent:not([data-modal-content]) {
    height: calc(100% - var(--navbar-height) - var(--banner-height));
    margin-top: calc(var(--navbar-height) + var(--banner-height));
}

.fullScreenBody {
    flex: 1;
    min-height: 0;
    overflow: auto;
}
